import { MainMenu } from "@excalidraw/excalidraw/index";
import {
  signOutIcon,
  recordingToolIcon,
  recordingActiveIcon,
} from "@excalidraw/excalidraw/components/icons";
import { useApp, useEditorInterface } from "@excalidraw/excalidraw/components/App";
import { t } from "@excalidraw/excalidraw/i18n";
import { useClerk } from "@clerk/clerk-react";
import React from "react";
import { useAtomValue, useSetAtom } from "@excalidraw/excalidraw/editor-jotai";
import {
  recordingStatusAtom,
  recordingStateAtom,
} from "@excalidraw/excalidraw/recording/atoms";

import type { Theme } from "@excalidraw/element/types";

import { LanguageList } from "../app-language/LanguageList";

export const AppMainMenu: React.FC<{
  theme: Theme | "system";
  setTheme: (theme: Theme | "system") => void;
}> = React.memo((props) => {
  const { signOut } = useClerk();
  const editorInterface = useEditorInterface();
  const app = useApp();
  const recordingStatus = useAtomValue(recordingStatusAtom);
  const setRecordingState = useSetAtom(recordingStateAtom);

  const isRecording = recordingStatus === "recording";

  return (
    <MainMenu>
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      <MainMenu.DefaultItems.CommandPalette className="highlighted" />
      <MainMenu.DefaultItems.SearchMenu />
      <MainMenu.DefaultItems.Help />
      <MainMenu.DefaultItems.ClearCanvas />
      {isRecording ? (
        <MainMenu.Item
          icon={recordingActiveIcon}
          onSelect={() => {
            app.setActiveTool({ type: "custom", customType: "recorder" });
          }}
        >
          {t("recording.elapsed")}
        </MainMenu.Item>
      ) : (
        <MainMenu.Item
          icon={recordingToolIcon}
          onSelect={() => {
            setRecordingState((prev) => ({ ...prev, status: "settings" }));
            app.setActiveTool({ type: "custom", customType: "recorder" });
          }}
        >
          {t("recording.settingsTitle")}
        </MainMenu.Item>
      )}
      <MainMenu.Separator />
      <MainMenu.DefaultItems.ToggleTheme
        allowSystemTheme
        theme={props.theme}
        onSelect={props.setTheme}
      />
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
      <MainMenu.Separator />
      {editorInterface.formFactor !== "phone" && (
        <MainMenu.Item
          icon={signOutIcon}
          onSelect={() => signOut()}
        >
          {t("labels.signOut")}
        </MainMenu.Item>
      )}
    </MainMenu>
  );
});
